// extracted by mini-css-extract-plugin
export default {"fillintable":"tablecomponent_fillintable__wFe1t","blink_me":"tablecomponent_blink_me__5Q2i0","blinker":"tablecomponent_blinker__rveh4"};